var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"fade"}},[(_vm.state)?_c('div',{staticClass:"app-overlay-loader"},[_c('FaIcon',{staticClass:"app-overlay-loader-spinner",class:_vm.size,attrs:{"icon":"spinner","spin":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }